import React from "react";
import { Popconfirm, Icon } from "antd";
import { compose, withHandlers } from "recompose";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import * as gtag from "../../lib/gtag";
import { canCreateOpportunity } from "../../store/selectors/user";
import {
  cloneOpportunity,
  CLONE_OPPORTUNITY
} from "../../store/actions/opportunity";
import Button from "../Button";

const CloneButton = ({
  t,
  handleClone,
  isDisabled,
  isLoading,
  canCreateOpportunity
}) =>
  !canCreateOpportunity ? null : (
    <Popconfirm
      placement="topLeft"
      title={t("opportunity:details.cloneAlert")}
      onConfirm={handleClone}
      okText={t("global:accept")}
      cancelText={t("global:cancel")}
    >
      <Button
        type="quaternary"
        loading={isLoading}
        disabled={isDisabled || isLoading}
      >
        {t("opportunity:details.clone")}
        <Icon type="file-add" />
      </Button>
    </Popconfirm>
  );

export default compose(
  withTranslation(["global", "opportunity"]),
  connect(
    state => ({
      isLoading: CLONE_OPPORTUNITY.getStatus(state) === "pending",
      canCreateOpportunity: canCreateOpportunity(state.user)
    }),
    {
      cloneOpportunity
    }
  ),
  withHandlers({
    handleClone: ({ cloneOpportunity, opportunity }) => () => {
      cloneOpportunity(opportunity);
      gtag.event({
        category: "VacancyDetail",
        action: "VacancyDetail.Duplicate",
        label: opportunity.id
      });
    }
  })
)(CloneButton);
